import 'components/Modal/modal.scss'
import MODAL_COMPONENTS from 'modules/Modals'
import React, { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import styles from 'components/Modal/modal.module.scss'
import { LOCALES } from 'constants/app-config'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { ROUTES } from 'constants/routes'
import ModalComponent from 'components/Modal/subcomponents/Modal'

const localePathSegment = new RegExp(`(?:\\/)(?:${LOCALES.join('|')})(?:\\/)`)

const BREAKPOINTS_DEFAULT = {
  0: {
    variant: 'bottomSheet',
  },
  768: {
    variant: 'default',
  },
}

export default function ModalContainer() {
  const history = useHistory()
  const pathGen = useGeneratePathI18n()
  const dispatch = useDispatch()

  const modals = useSelector((state) => state.modal.modals)

  const removeModal = useCallback((modal) => {
    dispatch({ type: 'MODAL/REMOVE', payload: { ...modal } })
  }, [])

  const onRequestClose = useCallback(
    (modal) => {
      if (modal.openFrom) {
        history.push(modal.openFrom.replace(localePathSegment, pathGen(ROUTES.MAIN)))
      }

      removeModal(modal)
    },
    [history, removeModal],
  )

  useEffect(() => {
    modals.forEach((modal) => {
      !!modal.closeRequest && onRequestClose(modal)
    })
  }, [modals, onRequestClose])

  const handlePopstate = useCallback(() => modals.forEach((modal) => removeModal(modal)), [modals])

  useEffect(() => {
    window.addEventListener('popstate', handlePopstate)

    return () => {
      window.removeEventListener('popstate', handlePopstate)
    }
  }, [handlePopstate])

  return (
    <div className={styles.modalContainer}>
      {modals.map((modal) => {
        if (!modal.modalProps.breakpoints) {
          modal.modalProps.breakpoints = BREAKPOINTS_DEFAULT
        }

        if (modal.modalType) {
          const SpecifiedModal = MODAL_COMPONENTS[modal.modalType]
          return (
            <ModalComponent
              key={modal.UUID}
              modal={modal}
              SpecifiedModal={SpecifiedModal}
              onRequestClose={onRequestClose}
            />
          )
        }

        return null
      })}
    </div>
  )
}
